import Joi from 'joi';
import { YEARS_ACCOMODATION } from '../LegalParameters/Constants';

export default Joi.object({
	persons: Joi.number()
		.integer()
		.min(1)
		.max(10),
	citySize: Joi.number()
		.integer()
		.min(0)
		.max(4),
	contract: Joi.number()
		.integer()
		.min(0)
		.max(1),
	cost: Joi.number()
		.positive()
		.error(() => ({
			message: 'Náklady na bydlení musí být celé kladné číslo.',
		})),
	income: Joi.number()
		.positive()
		.error(() => ({
			message: 'Čistý příjem musí být celé kladné číslo.',
		})),
	year: Joi.valid(YEARS_ACCOMODATION),
});
